var lists_default = {
  "fontElementMap": "woel9",
  "orderedlist": "pvUR1",
  "bulletedlist": "e-JYK",
  "listItem": "-yD1r"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
